import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import NewsletterService from "services/newsletter.service";

export default function Footer() {

  const [success, setSuccess] = useState(false);

  const handleSub = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior

    // Access the input value by name
    const email = e.target.elements['email'].value;
    NewsletterService.newSub(email)
      .then(response => {
        const message = response.data.message;
        setSuccess(true);
      })
      .catch(error => {
        console.error(error);
      });
  };

  return (
    <>
      <footer className="relative bg-blueGray-200 pt-8 pb-6">
        <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container mx-auto px-4">
          <div className="flex flex-row">
            <div className="w-full md:w-6/12 px-4">
              <a href="/como-participar-subastas-boe" className="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold block py-1">
                Participar en Subastas del BOE
              </a>
              <a href="/cargas-bien-subastado" className="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold block py-1">
                Cargas de un bien subastado
              </a>
              <a href="/que-es-nota-simple" className="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold block py-1">
                ¿Qué es una Nota Simple?
              </a>
            </div>
            <div className="w-full flex flex-col items-end justify-end">
              <h4 className="text-3xl font-semibold text-sky-900 text-right">
                ¿Tienes alguna pregunta?
                <br />
                ¡Escríbenos!
              </h4>

              <a
                className="text-xl mt-2"
                href="mailto:hola@subastasboepro.com"
                target='_blank'
              >
                hola@subastasboepro.com
              </a>
            </div>
          </div >
          <hr className="my-6 border-blueGray-300" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center text-blueGray-500 font-semibold">
              <div className="text-sm py-1">
                Copyright © {new Date().getFullYear()}{" "}
                <a
                  href="https://www.subastasboepro.com"
                  className="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold py-1"
                >
                  SubastasBOEPro.com
                </a>
              </div>
              Hecho con 💗 & 🤖
            </div>
          </div>
        </div >
      </footer >
    </>
  );
}
